<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		
		<nemunav :list="navList" navBgImg="product" :menutitle="menutitle" @tapMenu="tapMenu"  :navIndex="selectIndex"></nemunav>

		<!-- <product1 @tapList="handleTapList" v-if="selectIndex==0" :list="list"></product1>
		<product2 v-if="selectIndex==1" :list="list"></product2> -->
		<!-- <product2 v-if="selectIndex==0" :list="list" :total="total" @currentchange="currentchange"></product2> -->
		
		<application v-if="selectIndex==0" :list="applist" :total="apptotal" :selectIndex="caseTypeIndex" @changeCaseType="changeCaseType"></application>

		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import {
	  productlisten,
	  applicationlisten
	} from '@/api/home.js';
	import mobilemenu from "@/components/en/mobile-menu.vue";
	import header1 from "@/components/en/header.vue";
	import nemunav from "@/components/en/nemunav.vue";
	import product1 from "@/components/en/product/index1.vue";
	import product2 from "@/components/en/product/index2.vue";
	import footer1 from "@/components/en/footer.vue";
	import application from "@/components/en/product/application.vue";
	export default {
		components: {
			mobilemenu,
			header1,
			footer1,
			nemunav,
			product1,
			product2,
			application
		},
		data() {
			return {
				pathname: "/en/product",
				menutitle:"Product",
				// navList:["Intelligent products", "Intelligent manufacturing"],
				navList:["Intelligent products"],
				selectIndex:0,
				isShowMobile:false,
				pageNum:1,
				list:[],
				total:0,
				productType:1,
				
				pageNum:1,
				apptotal:0,
				caseTypeIndex:1,
				selectIndex:0,
				applist:[]
				
			}
		},
		created() {
			this.selectIndex = this.$route.query.index?this.$route.query.index:0
			// this.getproductlist()
			this.getapplicationlist()
		},
		methods: {
			changeCaseType(e) {
				this.caseTypeIndex = e
				// this.getcaselist()
				this.getapplicationlist()
			},
			handleTapList(index) {
				console.log(index)
				this.productType = index
				this.$nextTick(() => {
					this.getproductlist()
				})
			},
			getapplicationlist(){
				applicationlisten({
				  pageNum: this.pageNum,
					pageSize:10,
					applicationType:this.caseTypeIndex
				}).then(res => {
				  if (res.data.code == 200) {
				    this.applist = res.data.rows
					this.apptotal = res.data.total
				  }
				})
			},
			getproductlist() {
			  productlisten({
			    pageNum: this.pageNum,
				pageSize:10,
			  }).then(res => {
			    if (res.data.code == 200) {
					var arr1 = []
					var arr = res.data.rows
					for(var i=0; i < arr.length; i++) {
						var item = arr[i]
						item['content1'] = this.filtersText(item.productIntroduce)
										if(item.profile!=""){
										  item.profile = item.profile.split(",")[0]
										}
						arr1.push(item)
					}
					this.list = arr1
			      // this.list = res.data.rows.map(item => {
			      //   if(item.profile!=""){
			      //     item.profile = item.profile.split(",")[0]
			      //   }
			      //   return item
			      // })
			    }
			  })
			},
			currentchange(e) {
				this.pageNum = e
				this.getproductlist()
			},
			filtersText(val){
			        if (val != null && val != '') {
			            let reg = /[\u4e00-\u9fa5]/g;
			            let names = val.match(reg);
			            val = names ? names.join('') : '';
			            return val;
			        } else return '';
			    },
			
			tapMenu(e) {
				this.selectIndex = e
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}
			

		}
	}
</script>

<style lang="scss">
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px; 
		}
	
	}
</style>
